export const callerTitlesMap = {
  lotSizeCalculator: 'Lot Size Calculator',
  patternAlerts: 'Pattern Alert',
  navigationBar: 'Charts',
  tradingSimulator: 'Trading Simulator',
  symbolSelect: 'Symbol Select',
  backtester: 'Backtest Symbol Select',
}
